import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Formalization.scss';
import i18n from '../../../../i18n';

const roomTypes = {
  zhiloeRoom: i18n.t('components.building.main.formalization.zhiloeRoom'),
  partFlat: i18n.t('components.building.main.formalization.partFlat'),
  nezhiloeRoom: i18n.t('components.building.main.formalization.nezhiloeRoom'),
  apartmentRoom: i18n.t('components.building.main.formalization.apartmentRoom'),
  apartRoom: i18n.t('components.building.main.formalization.apartRoom'),
  zhiloeHouse: i18n.t('components.building.main.formalization.zhiloeHouse')
};

const Formalization = ({ className, building, client, print }) => {
  const { room_types: roomType, count_flats } = building.data;

  const { t } = useTranslation();

  const roomTypeNames = [];
  if (roomType) {
    roomType.forEach((type) => {
      if (roomTypes[type]) {
        roomTypeNames.push(<br key={`${type}-br`} />);
        roomTypeNames.push(
          <span key={`${type}-span`}>
            {t(`components.building.main.formalization.${type}`)}
          </span>
        );
      }
    });
  }
  roomTypeNames.shift();

  return (
    <div className={cn(styles.Formalization, { [styles.Client]: client }, className, { [styles.FormalizationPrint]: print })}>
      <h3 className={client ? styles.TitleClient : styles.Title}>
        {t('components.building.main.formalization.title')}
      </h3>
      <div className={client ? styles.InnerClient : styles.Inner}>
        <div className={styles.Row}>
          <div className={styles.Label}>
            {t('components.building.main.formalization.label')}
          </div>
          <div className={styles.Name}> {`${building.data.checkout ? `${building.data.checkout},` : ''} ${building.data.checkout2}`} </div>
        </div>

        {count_flats && roomTypeNames.length > 0 ? (
          <div className={styles.Row}>
            <div className={styles.Label}>
              {t('components.building.main.formalization.type')}
            </div>
            <div className={cn(styles.Name, styles.RoomTypes)}>
              <span>{roomTypeNames}</span>
            </div>
          </div>
        ) : null}

        {/* count_flats ? (
          <div className={styles.Row}>
            <div className={styles.Label}>
              {t('components.building.main.formalization.sum')}
            </div>
            <div className={styles.Name}>
              {building.data.contract_total
                ? t('components.building.main.formalization.full')
                : t('components.building.main.formalization.part')
              }
            </div>
          </div>
        ) : null */}
      </div>
    </div>
  );
};

export default Formalization;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Formalization/Formalization.js